import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment, endpoints } from '@environment';
import { Dashboard } from '@core/models';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/${endpoints.v1.dashboard}`;

  getDashboard(): Observable<Dashboard | null> {
    return this.http.get<Dashboard | null>(this.baseUrl);
  }
}
